var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"app-container grid-area"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.section.name))])]),_c('div',{staticClass:"section-body"},[_c(_vm.componentToShow,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }